import gql from 'graphql-tag';
import { Fragments } from '../fragments';

export const updateWorkflow = gql`
  mutation UpdateWorkflowTemplateMutation($input: UpdateWorkflowTemplate!) {
    updateWorkflowTemplate(input: $input) {
      ...WorkflowTemplate
    }
  }

  ${Fragments.workflow.WorkflowTemplate}
`;

export const createWorkflow = gql`
  mutation CreateWorkflowTemplateMutation($input: CreateWorkflowTemplate!) {
    createWorkflowTemplate(input: $input) {
      ...WorkflowTemplate
    }
  }

  ${Fragments.workflow.WorkflowTemplate}
`;

export const duplicateWorkflow = gql`
  mutation DuplicateWorkflowTemplateMutation($input: DuplicateWorkflowTemplate!) {
    duplicateWorkflowTemplate(input: $input) {
      ...WorkflowTemplate
    }
  }

  ${Fragments.workflow.WorkflowTemplate}
`;

export const createWorkflowTemplates = gql`
  mutation CreateWorkflowTemplatesMutation($input: CreateWorkflowTemplates!) {
    createWorkflowTemplates(input: $input) {
      ...WorkflowTemplate
    }
  }

  ${Fragments.workflow.WorkflowTemplate}
`;
